export * from './diagnostic-position.module';
export * from './diagnostic-position.component';
